import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { FilterPill } from '../Table/FilterPill'
import { colors } from '../../const/colors'

const HIDFilters = ({
  hasAccount,
  setHasAccount,
  activeCard,
  setActiveCard,
}: {
  hasAccount: string
  setHasAccount: (v: string) => void
  activeCard: string
  setActiveCard: (v: string) => void
}) => {
  const { t } = useTranslation(['hid', 'generic', 'btn'])
  const hasActiveFilters = !!hasAccount || !!activeCard

  const yesNoOptions = [
    { value: 'yes', label: t('generic:yes') },
    { value: 'no', label: t('generic:no') },
  ]

  const clearAll = () => {
    setHasAccount('')
    setActiveCard('')
  }

  return (
    <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
      <FilterPill
        label={t('card_created')}
        value={hasAccount}
        options={yesNoOptions}
        onSelect={v => setHasAccount(v === hasAccount ? '' : v)}
      />
      <FilterPill
        label={t('mobile_card_activity')}
        value={activeCard}
        options={yesNoOptions}
        onSelect={v => setActiveCard(v === activeCard ? '' : v)}
      />
      {hasActiveFilters && (
        <Typography
          onClick={clearAll}
          sx={{
            color: colors.slate,
            fontWeight: 600,
            fontSize: '13px',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            transition: 'color .15s',
            '&:hover': { color: colors.navy },
          }}
        >
          {t('btn:clear_filters')}
        </Typography>
      )}
    </Box>
  )
}

export default HIDFilters
